<script setup lang="ts">
import TaskInfoLayer from './TaskInfoLayer.vue'
import ButtonTaskCancel from './creation/ButtonTaskCancel.vue'
import ButtonTaskCreate from './creation/ButtonTaskCreate.vue'
import TaskCommon from './task-info/TaskCommon.vue'
import TaskGeneralInfoCreate from './task-info/TaskGeneralInfoCreate.vue'
import TaskResponsible from './task-info/TaskResponsible.vue'
import TaskRelations from './task-info/TaskRelations.vue'
import TaskAdditionalDetails from './task-info/TaskAdditionalDetails.vue'
import TaskComments from './task-info/TaskComments.vue'

defineOptions({
  name: 'SectionTaskInfoCreate',
})

</script>

<template>
  <TaskInfoLayer
    title="Task"
  >
    <template #general>
      <TaskGeneralInfoCreate />
    </template>
    <template #responsible>
      <TaskResponsible />
    </template>
    <template #relations>
      <TaskRelations />
    </template>
    <template #common>
      <TaskCommon />
    </template>
    <template #default>
      <TaskAdditionalDetails />
      <TaskComments />
    </template>
    <template #actions>
      <ButtonTaskCancel />
      <ButtonTaskCreate />
    </template>
  </TaskInfoLayer>
</template>
